import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import LandingHeader from "../Components/LandingHeader";
import { Images } from "../Components/Images";
import Select from "react-select";
import InnerFooter from "../Components/InnerFooter";
import { UseMarketsInfo } from "../Hooks/UseMarkets";
import { GetPlanInfo, getTokenOptions } from "../actions/markets";
import Config from "../Config/index";
import { getPlanData, getUserDashData } from "../actions/user";
import { getAccount } from "../Hooks/useAccount";
import { SOCKET_URL } from "../Config/env";
import io from "socket.io-client";
import { isEmpty, ObjectIsempty } from "../lib/isEmpty";
import { useNavigate, Link } from "react-router-dom";
import { CHAINS } from "../Config/env";
import { SwitchChainS, setChainId, CURRENT_CHAIN_ID } from "../Hooks/useWeb3";
import { AddTransaction } from "../actions/markets";
import { useDispatch } from "react-redux";
import { NETWORK_SWITCH } from "../actions/types";
import {
  UseTriggerArbitrage,
  UseTriggerArbitragePoly,
  toFixedNumber,
} from "../Hooks/useWeb3";
import { toast } from "react-hot-toast";
import { convertUSD } from "../actions/markets";
import Header from "../layout/Header";
import NewFooter from "../layout/Footer";
import { userPlanDetail } from "../Hooks/UseContract";

const Dashboard = () => {
  const user = getAccount();
  const currencyRef = useRef();
  const [closer, setCloser] = useState();
  const [data, setData] = useState([]);
  const [data1, setData1] = useState({});
  const [option, setoption] = useState([]);
  const [stats, setstats] = useState({});
  const [ChangingData, setChangingData] = useState({});
  const navigate = useNavigate();
  const [chainId, set_ChainId] = useState(CHAINS[0]?.CHAIN_ID);
  const [opper, setOpper] = useState();
  const [isPending, setPending] = useState(false);
  const [isPending1, setPending1] = useState(false);
  const [isSuccess, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [userInfo, setUserInfo] = useState({});
  const [quantity, setQuantity] = useState();
  const [maxFlashLoan, SetMaxFlashLoan] = useState();
  const [loanAmount, setLoanAmount] = useState(0);
  const [loanIndex, setLoanIndex] = useState(0);
  const [USDPrice, setUSDPrice] = useState(0);
  const [USDProfit, setUSDProfit] = useState(0);
  const [planExpiry, setplanExpiry] = useState();
  const [degreesprofitpercentage, setdegreesprofitpercentage] = useState(0)
  const [Plandata, setPlandata] = useState({});




  console.log('getAccount', getAccount());

  useEffect(() => {
    set_ChainId(CHAINS[localStorage?.CHAIN]?.CHAIN_ID);
  }, [localStorage?.CHAIN]);

  const [selectedCurrency, setSelectedCurrency] = useState();
  //   {
  //   // value: "bnb",
  //   // label: "bnb",
  //   // img: Images.tron,
  // }
  const [index, setindex] = useState(0);
  const dispatch = useDispatch();


  useEffect(() => {
    DashData();
    getOption();
    setUserInfo(
      sessionStorage.getItem("user") &&
      JSON.parse(sessionStorage.getItem("user"))
    );
    userPlanData()
    userPlanFromDB()

  }, [user, userInfo]);

  const DashData = async () => {
    let { status, message, result } = await getUserDashData({ address: user });
    console.log("DashData ~ result:", result);
    setstats(result);

    const degrees = (Number(result?.tradeProfit) / 100) * 360;
    setdegreesprofitpercentage(degrees)
  };

  const changeIndex = async () => {
    let newIndex = (index + 1) % data.length;
    console.log(newIndex, "newIndex");
    setindex(newIndex);
    let changeData = { ...data[newIndex]?.data };
    console.log(changeData, "changeData");
    if (!isEmpty(changeData)) {
      let symbol = changeData.symbol.split("-")[1];
      let usdPriceProfit = await convertUSD(symbol);
      let profit = changeData.gains?.split(" ")[0];
      changeData["profitusd"] = Number(profit) * usdPriceProfit.data;
      console.log(changeData, "changeData");
      setData1(changeData);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (data.length > 0) {
        changeIndex();
      }
    }, 8000);

    return () => clearInterval(intervalId);
  }, [data, index]);

  useEffect(() => {
    ChangeIndex1();
  }, [data, index]);


  const userPlanData = async () => {
    let userP = await userPlanDetail()
    console.log("userP>>>>", userP)
    if (userP.subscribeId != "") {
      // setplanExpiry(new Date(Number(userP.validTill) * 1000).getTime())
    }
  }




  const userPlanFromDB = async () => {
    try {
      let { status, message, data } = await getPlanData({
        userId: userInfo?._id,
      });
      console.log("userInfouserInfo", data);


      if (status == true) {
        setplanExpiry(Number(data.expiryTime) * 1000);
      }

      await GetPlanInfo({ id: userInfo?.subscriptionPlans[0]?.planId })
        .then((info) => {

          if (info?.status == "success") {
            setPlandata(info?.data)
          }
          console.log("infoinfoinfo", info);



        })
        .catch((e) => console.log("Error : ", e));
      console.log(status, message, data, "status, message, data");
    } catch (err) {
      console.log(err);
    }
  };



  const ChangeIndex1 = async () => {
    let changeData = { ...data[index]?.data };
    console.log(changeData, isEmpty(changeData), "changeData");
    if (!isEmpty(changeData)) {
      let symbol = changeData.symbol?.split("-")[1];
      // changeData["profitusd"] = await convertUSD(symbol);
      let usdPriceProfit = await convertUSD(symbol);
      let profit = changeData.gains?.split(" ")[0];
      changeData["profitusd"] = Number(profit) * usdPriceProfit.data;
      // setData1(data[index]?.data);
      setData1(changeData);
    }
  };
  // const getOption = async()=>
  // {
  //   const {result,loading} = await getTokenOptions()
  //   let  options = result.length>0?result.map((data)=>({
  //     value: data.symbol,
  //     label: data.symbol,
  //     img: data.logoURI,
  //   })):[]
  //   setoption(options)
  //   console.log("options",options);
  // }

  const getOption = async () => {
    const { result, loading } = await getTokenOptions();
    let options =
      result.length > 0
        ? result.map((data) => ({
          value: data.symbol,
          label: data.symbol,
          img: data.logoURI,
        }))
        : [];
    setoption(options);
  };

  const handleChange = (e) => {
    setSelectedCurrency(e);
    const findOpper = data.find(
      (val) =>
        val?.data?.token0?.symbol == e.value ||
        val?.data?.token1?.symbol == e.value
    );
    if (findOpper) {
      setOpper(findOpper.data);
      toast.success("Opportunites Found!Click confirm To Trade");
    } else {
      setOpper({});
      toast.error("There is no opportunites found for this token");
    }
  };

  const handleChange1 = async (quantity) => {
    if (opper && !isEmpty(opper.trade)) {
      setQuantity(quantity.target.value);

      let decimal = /^\d+(\.\d+)?$/;
      if (!decimal.test(quantity.target.value)) {
        toast.error("Quantity must be a valid number");
      }

      let USDPrice = await convertUSD(selectedCurrency.value);
      setUSDPrice(quantity.target.value * USDPrice.data);
      // let loanAmountIN = 0;
      // if (
      //   opper?.trade?.loanAmounts &&
      //   parseInt(opper?.trade?.loanAmounts[0]) == 0
      // ) {
      //   setLoanAmount(opper?.trade?.loanAmounts[1]);
      //   setLoanIndex(1);
      //   loanAmountIN = opper?.trade?.loanAmounts[1];
      // } else if (opper?.trade?.loanAmounts) {
      //   setLoanAmount(opper?.trade?.loanAmounts[0]);
      //   setLoanIndex(0);
      //   loanAmountIN = opper?.trade?.loanAmounts[0];
      // }
      if (userInfo && userInfo != undefined) {
        GetPlanInfo({ id: userInfo?.subscriptionPlans[0]?.planId })
          // GetPlanInfo({ id: userInfo?.plan[userInfo?.plan?.length - 1]?._id })
          .then((info) => {

            console.log("infoinfoinfo", info);

            SetMaxFlashLoan(info.data.flashLoanAmount);
            // if (loanAmountIN > info.data.flashLoanAmount) {
            setLoanAmount(info.data.flashLoanAmount);
            ChangeLoan(quantity.target.value);
            // }
          })
          .catch((e) => console.log("Error : ", e));
      }
    } else {
      toast.error("Select A Trade Token!");
    }
  };

  const ChangeLoan = (quantity) => {
    var loan = quantity || 0;
    if (parseFloat(loan) > parseFloat(maxFlashLoan))
      return toast.error(`Max Flash loan for this plan is ${maxFlashLoan}`);
    // const loans = toFixedNumber(parseInt(loan || 0) * 10 ** 18);
    const loans = toFixedNumber((loan || 0) * 10 ** 18);
    setLoanAmount(loans);
    let loanAmounts = [];
    loanAmounts[0] = loanIndex == 0 ? loans : "0";
    loanAmounts[1] = loanIndex == 1 ? loans : "0";
    setTradeValue("loanAmounts", loanAmounts);
    setTradeValue("amounts", loanAmounts);
  };
  const setTradeValue = (key, value) => {
    setOpper((trade) => {
      trade[key] = value;
      return trade;
    });
  };

  const customCurrencyRenderer = ({ label, data, value }) => (
    <div
      className="market_select_component"
      onClick={() => {
        setSelectedCurrency({ label, value, img: data.img });
        currencyRef.current.blur();
        setCloser(!closer);
      }}
    >
      <img src={data.img} style={{ width: "20px", marginRight: "10px" }} />
      {label}
    </div>
  );

  const styles = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      color: "#fff",
      background: isFocused
        ? "#00CABA"
        : isSelected
          ? "#00CABA"
          : isHovered
            ? "red"
            : "#00CABA",

      zIndex: 1,
      cursor: "pointer",
      fontSize: "13px",
    }),

    option: (styles, { isFocused, isSelected, isHovered }) => {
      // const color = chroma(data.color);

      return {
        ...styles,
        backgroundColor: isHovered
          ? "#00F0FF"
          : isSelected
            ? "#00F0FF"
            : isFocused
              ? "#00F0FF"
              : "#141414",
        cursor: "pointer",
        color: isHovered
          ? "#000"
          : isSelected
            ? "#000"
            : isFocused
              ? "#000"
              : "#fff",
        fontSize: "13px",
      };
    },
    indicatorSeparator: (styles) => ({ display: "none" }),
    valueContainer: (provided, { isFocused, isSelected, isHovered }) => ({
      ...provided,
      height: "40px",
      paddingLeft: "40px",
      //   border: "1px solid #e3e0e0",
      backgroundColor: isHovered
        ? "transperant"
        : isSelected
          ? "transperant"
          : isFocused
            ? "transperant"
            : "transperant",
      // border: "1px solid rgba(34, 34, 34, 0.32)",
      borderRadius: 5,
      fontSize: "13px",
      color: "#fff",
    }),
    control: (provided, { isFocused, isSelected, isHovered }) => ({
      ...provided,
      height: "40px",
      //   border: "1px solid #00CABA",
      borderRadius: 5,
      backgroundColor: isHovered
        ? "transperant"
        : isSelected
          ? "transperant"
          : isFocused
            ? "transperant"
            : "transperant",
      // backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none",
      color: "#fff",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "#fff",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#fff",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
      borderRadius: "5px",
    }),
  };

  useEffect(() => {
    // UseMarketsInfo().then((info) =>{
    //   console.log("sddsssfsdfsd",info);
    //   setData(info)} );
    UseMarketsInfo().then((datas) => {
      console.log("🚀 ~ UseMarketsInfo ~ datas:", datas);
      const Datas = Object.keys(datas)
        .map((symbol) => {
          if (chainId === datas[symbol]?.chainId) {
            return {
              symbol,
              data: datas[symbol],
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setData(Datas);
      // setData1(Datas[Datas?.length-1]?.data)
    });

    const socket = io(SOCKET_URL, { transports: ["polling"] });
    const handleMessage = throttle((message) => {
      message = JSON.parse(message);
      let colors = "";
      // setData1(message)
      setData((datas) => {
        if (chainId === message.chainId) {
          datas[message?.symbol] = { ...message, color: colors };
          data.push(message);
          return datas;
        } else {
          return datas;
        }
      });
    }, 1000);

    socket.on("arbiInfo", (message) => {
      handleMessage(message);
    });

    return () => {
      socket.disconnect();
    };
  }, [chainId]);

  const throttle = (func, limit) => {
    let inThrottle;
    return function () {
      const context = this,
        args = arguments;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  };


  useEffect(() => {
    window.scroll(0, 0);
  }, []);


  return (
    <>
      <Container fluid className="p-0 position-relative common_bg">
        {/* <img
          src={Images.radiantBlur}
          className="home__dashboardLeftBlur img-fluid"
          alt=""
        />
        <img
          src={Images.radiantBlur}
          className="home__dashboardRightBlur img-fluid"
          alt=""
        /> */}
        {/* <LandingHeader /> */}
        <Header />
        <Container fluid className="p-0 custom_container">
          <Container className="home__indexAligner innerpages_ui">
            <div className="plans__holder">
              <h4 className="m-0 hebrew_bold opportunity__title">Dashboard</h4>
              <p className="plans__titleHint m-0 hebrew_font position-relative mt-2">
                All your Sector-8 activity in one clear overview.

              </p>
              <Row className="mt-4 h-100">
                <Col lg={8}>
                  <div className="dashboard__blueBox p-4 rounded-2 h-100">
                    <h4 className="m-0 hebrew_bold dashboard__midGrad">
                      Sector8 Stats
                    </h4>

                    <Row className="mt-4">
                      <Col sm={8}>
                        <Row>
                          <Col sm={6} className="mb-3">
                            <div className="dashboard__pinkBox rounded-2 py-3">
                              <p className="m-0 hebrew_strong dashboard__boxTitle text-center dashboard__blueTitle">
                                No.of Trade
                              </p>
                              <h6 className="m-0 hebrew_bold dashboard__tradeValue text-center">
                                {stats?.totalTrade ? stats?.totalTrade : 0}
                              </h6>
                            </div>
                          </Col>
                          <Col sm={6} className="mb-3">
                            <div className="dashboard__greenBox rounded-2 py-3">
                              <p className="m-0 hebrew_strong dashboard__boxTitle text-center dashboard__greenTitle">
                                Total Trade Volume
                              </p>
                              <p className="m-0 hebrew_bold dashboard__dollarValue text-center">
                                ${stats?.tradeVolume ? stats?.tradeVolume : 0}
                              </p>
                            </div>
                          </Col>
                          <Col sm={6} className="mb-3 mb-sm-0">
                            <div className="dashboard__skyBox rounded-2 py-3">
                              <p className="m-0 hebrew_strong dashboard__boxTitle text-center dashboard__blueTitle">
                                Total Earned
                              </p>
                              <p className="m-0 hebrew_bold dashboard__dollarValue text-center">
                                ${stats?.tradeProfit ? stats?.tradeProfit : 0}
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </Col>

                      <Col sm={4} className="mb-3 mb-sm-0">
                        <div className="dashboard__skyBox rounded-2 py-3">
                          <div className="custom_circle_bar">
                            <div
                              className="circular-progress"
                              style={{
                                background: `conic-gradient(#00F0FF ${degreesprofitpercentage}deg, #0a0a0c 0deg)`,
                              }}
                            >

                              {console.log("stats", stats)}

                              <div className="inner-circle"></div>
                              <div className="mb-0 percentage">
                                <p className="label_txt mb-0">Reached Profit Amount</p>
                                <p className="value mb-0">$ {stats?.tradeProfit ? stats?.tradeProfit : 0}</p>
                                {console.log("stats?.userDetail?.maxProfitPer", stats?.userDetail?.maxProfitPer)}

                                <p className="ttl_value mb-0">/ {Plandata && Plandata
                                  ? parseFloat(Plandata?.fee) / 100 * parseInt(stats?.userDetail?.maxProfitPer)
                                  : 0}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <div>
                      <Row className="mt-4 h-100">
                        <Col md={6} className="mb-4 mb-md-0">
                          <div className="dashboard__blackBox h-100 rounded-2 p-3">
                            <h6 className="m-0 hebrew_bold dashboard__semiGrad text-uppercase mb-4">
                              USER STATS
                            </h6>
                            <div className="dashboard__singleFlex d-flex justify-content-between align-items-center mb-4">
                              <p className="dashboard__label m-0 hebrew_font">
                                Total Profit:
                              </p>
                              <p className="dashboard__label m-0 hebrew_font">
                                $ {stats?.tradeProfit ? stats?.tradeProfit : 0}
                              </p>
                            </div>
                            <div className="dashboard__singleFlex d-flex justify-content-between align-items-center mb-4">
                              <p className="dashboard__label m-0 hebrew_font">
                                Total Volume:
                              </p>
                              <p className="dashboard__label m-0 hebrew_font">
                                $ {stats?.tradeVolume ? stats?.tradeVolume : 0}
                              </p>
                            </div>

                            {stats?.userDetail?.subscriptionPlans?.length > 0 ? (
                              <div className="dashboard__singleFlex d-flex justify-content-between align-items-center mb-4">
                                <p className="dashboard__label m-0 hebrew_font">
                                  Plan Name:
                                </p>
                                <p className="dashboard__label m-0 hebrew_font">
                                  {stats?.userDetail?.subscriptionPlans[0]?.name
                                    ? stats?.userDetail?.subscriptionPlans[0]
                                      ?.name
                                    : ""}
                                </p>
                              </div>
                            ) : (
                              ""
                            )}

                            <div className="dashboard__singleFlex d-flex justify-content-between align-items-center mb-4">
                              <p className="dashboard__label m-0 hebrew_font">
                                Total Flash Loan Granted :
                              </p>
                              <p className="m-0 hebrew_bold dashboard__greenTxt text-uppercase">
                                {" "}
                                $
                                {/* {stats?.userDetail?.flashLoanLimit
                                  ? stats?.userDetail?.flashLoanLimit
                                  : 0} */}

                                {stats?.userDetail?.subscriptionPlans[0]?.flashLoanLimit
                                  ? stats?.userDetail?.subscriptionPlans[0]?.flashLoanLimit
                                  : 0}
                              </p>
                            </div>
                            <div className="dashboard__singleFlex d-flex justify-content-between align-items-center">
                              <p className="dashboard__label m-0 hebrew_font">
                                Limit left:
                              </p>
                              <p className="dashboard__whiteTxt m-0 hebrew_bold text-uppercase">
                                {" "}
                                $
                                {stats?.userDetail?.subscriptionPlans[0]
                                  ?.flashLoanLimit
                                  ? stats?.userDetail?.subscriptionPlans[0]
                                    ?.flashLoanLimit > 0
                                    ? stats?.userDetail?.subscriptionPlans[0]
                                      ?.flashLoanLimit
                                    : 0
                                  : 0}
                              </p>
                            </div>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="dashboard__blackBox h-100 rounded-2 p-3">
                            <h6 className="m-0 hebrew_bold dashboard__semiGrad text-uppercase mb-4">
                              Flash Loan
                            </h6>
                            <p className="dashboard__label m-0 hebrew_font">
                              Select Network
                            </p>
                            <div className="d-flex justify-content-center align-items-center gap-5 mt-3">
                              {CHAINS.map((e, i) => (
                                <div
                                  className="d-flex flex-column justify-content-center align-items-center gap-3"
                                  onClick={async () => {
                                    let SwitchRes = await SwitchChainS(i);
                                    if (SwitchRes) {
                                      setChainId(i);
                                      dispatch({
                                        type: NETWORK_SWITCH,
                                        payload: i.toString(),
                                      });
                                      set_ChainId(CHAINS[i]?.CHAIN_ID);
                                    }
                                  }}
                                >
                                  <img
                                    src={e.IMAGE}
                                    className="img-fluid opCard__coinImg"
                                    alt=""
                                  />
                                  <p className="m-0 hebrew_font dashboard__smallText text-center">
                                    {e.NAME}
                                  </p>
                                </div>
                              ))}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="dashboard__blueBox p-4 rounded-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="m-0 hebrew_bold dashboard__smallGrad text-uppercase">
                        MARKET OPPORTUNITIES
                      </h6>
                      <Link
                        className="dashboard__label m-0 hebrew_font"
                        to="/opportunities"
                      >
                        View all
                      </Link>
                    </div>
                    <div className="dashboard__dualCardFlex d-flex justify-content-start align-items-center gap-5 mt-3 pb-2">
                      <div className="dashboard__singleCard">
                        <div className="d-flex justify-content-start align-items-center gap-4">
                          <div className="opCard__topSecLeft">
                            <img
                              src={
                                !isEmpty(data1)
                                  ? data1?.token0?.logoURI
                                  : Images.tron
                              }
                              className="img-fluid opCard__coinImg"
                              alt=""
                            />
                            <p className="m-0 herbrew_reg opCard__CoinName mt-4 text-center text-uppercase">
                              {!isEmpty(data1) && data1?.token0?.symbol}
                            </p>
                          </div>
                          <p className="m-0 dashboard__transactAct">
                            <i class="fa-solid fa-plus" />
                          </p>
                          <div className="opCard__topSecLeft">
                            <img
                              src={
                                !isEmpty(data1)
                                  ? data1?.token1?.logoURI
                                  : Images.aave
                              }
                              className="img-fluid opCard__coinImg"
                              alt=""
                            />
                            <p className="m-0 herbrew_reg opCard__CoinName mt-4 text-center text-uppercase">
                              {!isEmpty(data1) && data1?.token1?.symbol}
                            </p>
                          </div>
                        </div>
                        <p className="m-0 dashboard__profit hebrew_strong text-center py-1">
                          Profit{" "}
                          <span className="ms-1">
                            {!isEmpty(data1) ? data1?.difference : 0}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="dashboard__blueBox p-4 rounded-2 mt-3">
                    <h6 className="m-0 hebrew_bold dashboard__smallGrad text-uppercase mb-3">
                      ARBITRAGE DETAILS
                    </h6>

                    <div className="dashboard__singleFlex d-flex justify-content-between align-items-center mb-2">
                      <p className="dashboard__label m-0 hebrew_font">DEX:</p>
                      <p className="dashboard__label m-0 hebrew_font">
                        {console.log(!isEmpty(data1), data1, "!isEmpty(data1")}
                        {!isEmpty(data1)
                          ? `${data1?.prices?.split(" ")[2]}-${data1?.prices?.split(" ")[5]
                          }`
                          : "-"}
                      </p>
                    </div>
                    <div className="dashboard__singleFlex d-flex justify-content-between align-items-center mb-2">
                      <p className="dashboard__label m-0 hebrew_font">
                        Swap Tokens:
                      </p>
                      <p className="dashboard__label m-0 hebrew_font">
                        {" "}
                        {!isEmpty(data1) ? data1.symbol : ""}{" "}
                      </p>
                    </div>
                    <div className="dashboard__singleFlex d-flex justify-content-between align-items-center mb-2">
                      <p className="dashboard__label m-0 hebrew_font">
                        Profit Percent(%):
                      </p>
                      <p className="dashboard__label m-0 hebrew_font">
                        {!isEmpty(data1) ? data1.difference : 0}
                      </p>
                    </div>
                    <div className="dashboard__singleFlex d-flex justify-content-between align-items-center mb-2">
                      <p className="dashboard__label m-0 hebrew_font">
                        Profit Amount:
                      </p>
                      <p className="dashboard__label m-0 hebrew_font">
                        {!isEmpty(data1) ? data1.gains : 0}
                      </p>
                    </div>
                    <div className="dashboard__singleFlex d-flex justify-content-between align-items-center mb-2">
                      <p className="dashboard__label m-0 hebrew_font">
                        Payout Token:
                      </p>
                      <p className="dashboard__label m-0 hebrew_font">
                        {!isEmpty(data1) ? data1?.token1?.symbol : ""}
                      </p>
                    </div>
                    <div className="dashboard__singleFlex d-flex justify-content-between align-items-center mb-2">
                      <p className="dashboard__label m-0 hebrew_font">
                        Profit Amount (USD):
                      </p>

                      <p className="dashboard__label m-0 hebrew_font">
                        $ {data1?.profitusd ? data1?.profitusd : 0}
                      </p>
                    </div>
                    <div className="dashboard__singleFlex d-flex justify-content-between align-items-center">
                      <p className="dashboard__label m-0 hebrew_font">
                        Platform Fee:
                      </p>
                      <p className="dashboard__label m-0 hebrew_font">0%</p>
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="dashboard__blueBox p-4 rounded-2 mt-4">
                <h6 className="m-0 hebrew_bold dashboard__smallGrad text-uppercase">
                  borrow
                </h6>
                <p className="m-0 hebrew_font dashboard__balance mt-2">
                  {/* Balance: $ 0.0000 */}
                </p>

                <Row className="justify-content-between align-items-center mb-3">
                  <Col sm={6} md={5} lg={3} className="mb-3 mb-md-0">
                    <div className="dashboard__blackBox rounded-2 px-3">
                      <div className="market_coinname_select position-relative">
                        {selectedCurrency?.img ? (
                          <img
                            src={
                              selectedCurrency?.img ? selectedCurrency?.img : ""
                            }
                            className="img-fluid market_coinname_img dashboard__selectedImg"
                          />
                        ) : (
                          ""
                        )}

                        <Select
                          className=""
                          defaultValue={selectedCurrency}
                          options={option}
                          value={selectedCurrency}
                          // components={{ Option: customCurrencyRenderer }}
                          ref={currencyRef}
                          styles={styles}
                          onChange={(e) => handleChange(e)}
                          placeholder="Select Token"
                        // menuIsOpen
                        />
                      </div>
                    </div>
                  </Col>
                  <Col sm={6} md={5} lg={3}>
                    <input
                      type="number"
                      placeholder="Change Quantity"
                      name="quantity"
                      min={0}
                      value={quantity}
                      onChange={(e) => handleChange1(e)}
                      className="transacHistory__input dashoard__cmnInput hebrew_font w-100 rounded-1"
                    />
                  </Col>
                </Row>
                <p className="dashboard__label m-0 hebrew_font text-end">
                  USD Price :{USDPrice} USD
                </p>
                <div className="mt-4">
                  <div className="dashboard__singleFlex d-flex justify-content-between align-items-center mb-4">
                    <p className="dashboard__label m-0 hebrew_font">Slippage</p>
                    <input
                      type="number"
                      min={0}
                      placeholder="Slippage"
                      className="transacHistory__input dashoard__cmnInput hebrew_font rounded-1"
                    />
                  </div>

                  <div className="dashboard__singleFlex d-flex justify-content-between align-items-center mb-4">
                    <p className="dashboard__label m-0 hebrew_font">
                      Borrowed Asset:
                    </p>
                    <p className="dashboard__label m-0 hebrew_font dashboard__greenLabel">
                      {selectedCurrency?.label ? selectedCurrency?.label : ""}{" "}
                      {/* <img
                        src={selectedCurrency.img}
                      /> */}
                    </p>
                  </div>

                  <div className="dashboard__singleFlex d-flex justify-content-between align-items-center mb-4">
                    <p className="dashboard__label m-0 hebrew_font">Amount:</p>
                    <p className="dashboard__label m-0 hebrew_font dashboard__greenLabel">
                      {opper?.amounts ? opper?.amounts[0] / 10 ** 18 : 0}{" "}
                      {selectedCurrency?.label ? selectedCurrency?.label : ""}{" "}
                    </p>
                  </div>

                  <div className="dashboard__singleFlex d-flex justify-content-between align-items-center mb-4">
                    <p className="dashboard__label m-0 hebrew_font">
                      difference (%):
                    </p>
                    <p className="dashboard__label m-0 hebrew_font dashboard__greenLabel">
                      {opper?.difference ? opper?.difference : 0}
                    </p>
                  </div>

                  <div className="dashboard__singleFlex d-flex justify-content-between align-items-center mb-4">
                    <p className="dashboard__label m-0 hebrew_font">
                      Payback Amount:
                    </p>
                    <p className="dashboard__label m-0 hebrew_font dashboard__greenLabel">
                      {Config.PaybackAmount}{" "}
                      {selectedCurrency?.label ? selectedCurrency?.label : ""}{" "}
                    </p>
                  </div>
                </div>

                <div className="text-center mt-4">

                  {console.log("planExpiry", planExpiry, Date.now())}

                  {chainId == 56 ? (
                    <button
                      className="primary_grad_btn primary_gradBtnWidth rounded-5"
                      onClick={async () => {
                        setPending(true);
                        if (stats?.userDetail?.subscriptionPlans?.length > 0) {
                          if (planExpiry > Date.now()) {
                            if (!isEmpty(quantity)) {
                              if (opper && !isEmpty(opper.trade)) {
                                UseTriggerArbitrage(opper.trade)
                                  .then(async (datas) => {
                                    let loanAmountIN = 0;
                                    if (
                                      opper?.loanAmounts &&
                                      parseInt(opper?.loanAmounts[0]) == 0
                                    ) {
                                      loanAmountIN = opper?.loanAmounts[1];
                                    } else if (opper?.loanAmounts) {
                                      loanAmountIN = opper?.loanAmounts[0];
                                    }
                                    let diff = opper.difference.split("%");
                                    loanAmountIN = loanAmountIN / 10 ** 18;
                                    let prof = (parseFloat(diff[0]) * loanAmountIN) / 100;
                                    prof = prof + loanAmountIN;
                                    let feeAmount = (0.09 * prof) / 100;
                                    prof = prof - feeAmount;
                                    let { status, message, result } =
                                      await AddTransaction({
                                        transactionHash: datas.transactionHash,
                                        address: getAccount(),
                                        token0: opper.token0,
                                        token1: opper.token1,
                                        symbol: opper.symbol,
                                        prices: opper.prices,
                                        difference: opper.difference,
                                        gains: opper.gains,
                                        trade: opper.trade,
                                        chainId: opper.chainId,
                                        amountIn: loanAmountIN,
                                        profit: prof,
                                      });

                                    setSuccess(true);
                                    setMessage(`Trade Success :  ${datas.transactionHash}`);
                                    toast.success(`Trade Success :  ${datas.transactionHash}`);
                                    setTimeout(() => setMessage(""), 30000);
                                    setPending(false);
                                    setOpper();
                                  })
                                  .catch((e) => {
                                    setSuccess(false);
                                    console.log(
                                      `Opportunity is missed ! : The Return Amount is Insufficient For Loan Repayment`
                                    );
                                    toast.error(
                                      `Opportunity is missed ! : The Return Amount is Insufficient For Loan Repayment`
                                    );
                                    setMessage(`Opportunity is missed ! : The Return Amount is Insufficient For Loan Repayment`);
                                    setPending(false);
                                    setTimeout(() => setMessage(""), 30000);
                                  });
                              } else {
                                console.log(opper, "OPPER");
                                toast.error(
                                  "Select A Token With Opportunites To Trade"
                                );
                                setPending(false);
                              }
                            }
                            else {
                              toast.error("Quantity Should Not 0");
                              setPending(false);
                            }
                          }
                          else {
                            console.log(opper, "OPPER");
                            toast.error(
                              "Your Plan Expired"
                            );
                            setPending(false);
                          }
                        }
                        else {
                          console.log(opper, "OPPER");
                          toast.error(
                            "Buy A subscription Plan To Trade!"
                          );
                          setPending(false);
                        }
                      }}
                    >
                      {isPending ? "Trading..." : "Confirm"}
                    </button>
                  ) : (
                    <button
                      className="primary_grad_btn primary_gradBtnWidth rounded-5"
                      onClick={async () => {
                        setPending(true);
                        if (stats?.userDetail?.subscriptionPlans?.length > 0) {
                          if (planExpiry >
                            Date.now()) {
                            if (!isEmpty(quantity)) {
                              if (opper && !isEmpty(opper.trade)) {
                                UseTriggerArbitragePoly(opper.trade)
                                  .then(async (datas) => {
                                    let loanAmountIN = 0;
                                    if (
                                      opper?.loanAmounts &&
                                      parseInt(opper?.loanAmounts[0]) == 0
                                    ) {
                                      loanAmountIN = opper?.loanAmounts[1];
                                    } else if (opper?.loanAmounts) {
                                      loanAmountIN = opper?.loanAmounts[0];
                                    }
                                    let diff = opper.difference.split("%");
                                    loanAmountIN = loanAmountIN / 10 ** 18;
                                    let prof =
                                      (parseFloat(diff[0]) * loanAmountIN) / 100;
                                    prof = prof + loanAmountIN;
                                    let feeAmount = (0.05 * prof) / 100;
                                    prof = prof - feeAmount;
                                    let { status, message, result } =
                                      await AddTransaction({
                                        transactionHash: datas.transactionHash,
                                        address: getAccount(),
                                        token0: opper.token0,
                                        token1: opper.token1,
                                        symbol: opper.symbol,
                                        prices: opper.prices,
                                        difference: opper.difference,
                                        gains: opper.gains,
                                        trade: opper.trade,
                                        chainId: opper.chainId,
                                        amountIn: loanAmountIN,
                                        profit: prof,
                                      });
                                    setSuccess(true);
                                    setMessage(
                                      `Trade Success :  ${datas.transactionHash}`
                                    );
                                    toast.success(
                                      `Trade Success :  ${datas.transactionHash}`
                                    );
                                    setTimeout(() => setMessage(""), 30000);
                                    setPending(false);
                                    setOpper();
                                  })
                                  .catch((e) => {
                                    setSuccess(false);
                                    console.log(
                                      `Opportunity is missed ! : The Return Amount is Insufficient For Loan Repayment`
                                    );
                                    toast.error(
                                      `Opportunity is missed ! : The Return Amount is Insufficient For Loan Repayment`
                                    );
                                    setMessage(
                                      `Opportunity is missed ! : The Return Amount is Insufficient For Loan Repayment`
                                    );
                                    setPending(false);
                                    setTimeout(() => setMessage(""), 30000);
                                  });
                              } else {
                                console.log(opper, "OPPER");
                                toast.error(
                                  "Select A Token With Opportunites To Trade"
                                );
                                setPending(false);
                              }
                            }
                            else {
                              toast.error("Quantity Should Not 0");
                              setPending(false);
                            }
                          }
                          else {
                            console.log(opper, "OPPER");
                            toast.error(
                              "Your Plan Expired"
                            );
                            setPending(false);
                          }
                        }
                        else {
                          console.log(opper, "OPPER");
                          toast.error(
                            "Buy A subscription Plan To Trade!"
                          );
                          setPending(false);
                        }
                      }}
                    >
                      {isPending ? "Trading..." : "Confirm"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </Container>
        </Container>
        {/* <InnerFooter /> */}
        <NewFooter />
      </Container>
    </>
  );
};

export default Dashboard;
